import { Input } from 'reactstrap'
import { CancelIcon, CheckMarkIcon, DnDIcon } from '../../../common/icons'
import { IInfoGoOrg } from '../../../../types/infogo'
import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import '../infogo-config.scss'
import OmsToolTip from '../../../common/tooltip/tooltip';
import useAuth from '../../../../hook/useAuth';
import { useId } from 'react';

type AssociatedOrgItemProps = {
    id: any
    org: IInfoGoOrg
    suppressed: boolean
    onSuppressCheck: (event: any) => void
    visible: boolean
    isDragging?: boolean
}

const AssociatedOrgItem = (props: AssociatedOrgItemProps) => {
    const { id, org, suppressed, onSuppressCheck, visible, isDragging } = props
    const { isFrenchTranslator } = useAuth()
    const { attributes, listeners, setNodeRef, transform, transition } = useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition
    }

    return (
        <div ref={setNodeRef}
            style={{ ...style, cursor: !isFrenchTranslator ? 'move' : 'inherit', opacity: isDragging && !isFrenchTranslator? 0.5 : 1, visibility: visible ? 'visible' : 'hidden' }}
            className="infogo-grid-row focus-ring"
            {...attributes}
            {...listeners} >
            <div className="infogo-assorg-col1">
                <div style={{ marginTop: '-2px' }}><DnDIcon /></div>
            </div>
            <div className="infogo-assorg-col2">
                {isDragging
                    ? <span style={{pointerEvents: "none"}}>{org.orgName}</span>
                    : <OmsToolTip id={`ass_${org.orgId}_tooltip_${id}`} orgId={Number(org.orgId)}>
                        <span style={{pointerEvents: "none"}}>{org.orgName}</span>
                    </OmsToolTip>
                }
            </div>
            <div className="infogo-assorg-col3">
               {!isFrenchTranslator &&  <Input type="checkbox"
                    aria-label="suppress"
                    checked={suppressed}
                    onChange={onSuppressCheck}
                />}
                { isFrenchTranslator && <div>{suppressed? <CheckMarkIcon title="Suppressed"></CheckMarkIcon>: <CancelIcon></CancelIcon>}</div>}
            </div>
        </div>
    )
}

export default AssociatedOrgItem
